module.exports = __webpack_public_path__ + "assets/message.d5dc7207.svg";